export default "__VITE_ASSET__BCiub2Nm__"